import { combineReducers } from 'redux'
import {
  FETCH_COUNTRY_CLUSTERS,
  FETCH_COUNTRY_CLUSTERS_ERROR,
  FETCH_COUNTRY_CLUSTERS_SUCCESS,
  FETCH_COUNTRY_STORES_LIST_SUCCESS,
  FETCH_STORE_DETAILS_SUCCESS,
  FILTER_BY_CLUSTER,
} from 'revenue/constants'
import { emptyArray } from 'utils'

import {
  FETCH_COMPLETENESS_GENERAL_REVENUE,
  FETCH_COMPLETENESS_GENERAL_REVENUE_ERROR,
  FETCH_COMPLETENESS_GENERAL_REVENUE_SUCCESS,
  FETCH_COUNTRIES,
  FETCH_COUNTRIES_ERROR,
  FETCH_COUNTRIES_SUCCESS,
  FETCH_DELAYED_STORES,
  FETCH_DELAYED_STORES_ERROR,
  FETCH_DELAYED_STORES_SUCCESS,
} from './constants'

const defaultCountryData = {
  clusters: [],
  revenueCurrent: 0,
  revenueCompared: 0,
  storesCurrent: 0,
  storesCompared: 0,
  trafficCurrent: 0,
  trafficCompared: 0,
}

const isFetching = (state = false, action) => {
  switch (action.type) {
    case FETCH_COUNTRIES:
      return action.dateCurrent ? state : true
    case FETCH_COUNTRIES_SUCCESS:
    case FETCH_COUNTRIES_ERROR:
      return false
    default:
      return state
  }
}

const isFetchingClusters = (state = false, action) => {
  switch (action.type) {
    case FETCH_COUNTRY_CLUSTERS:
      return true
    case FETCH_COUNTRY_CLUSTERS_SUCCESS:
    case FETCH_COUNTRY_CLUSTERS_ERROR:
      return false
    default:
      return state
  }
}

// eslint-disable-next-line sonarjs/cognitive-complexity
const list = (state = emptyArray, action) => {
  switch (action.type) {
    case FETCH_COUNTRIES_ERROR:
      return emptyArray
    case FETCH_COUNTRIES_SUCCESS:
      return action.countries
    case FETCH_COUNTRY_STORES_LIST_SUCCESS:
      return state.map(country => {
        if (country.countryId === action.countryId) {
          return {
            ...country,
            stores: action.stores,
          }
        }
        return country
      })
    case FETCH_STORE_DETAILS_SUCCESS:
      return state.map(country => {
        if (country.countryId === action.countryId) {
          return {
            ...country,
            stores: (country.stores || []).map(store => {
              if (store.storeId === action.storeId) {
                return {
                  ...store,
                  details: {
                    ...action.details,
                    storeReplenishment: action.storeReplenishment,
                    trafficHistory: action.trafficHistory,
                    results: action.results,
                    dateCurrent: action.dateCurrent,
                    dateCompared: action.dateCompared,
                  },
                }
              }

              return store
            }),
          }
        }
        return country
      })
    case FETCH_COUNTRY_CLUSTERS_SUCCESS:
      return state.map(country => {
        if (country.countryId === action.countryId) {
          const countryData = action.countries.find(c => c.countryId === action.countryId)
          return countryData ? { ...country, filteredData: countryData } : { ...country, filteredData: defaultCountryData }
        }
        return country
      })
    case FILTER_BY_CLUSTER:
      if (!action.countryId) return state
      return state.map(country => {
        if (country.countryId !== action.countryId) return country

        const filterByCluster = country.filterByCluster !== action.cluster ? action.cluster : null

        return {
          ...country,
          filterByCluster,
        }
      })
    default:
      return state
  }
}

const isFetchingCompletenessGeneralRevenue = (state = false, action) => {
  switch (action.type) {
    case FETCH_COMPLETENESS_GENERAL_REVENUE:
      return true
    case FETCH_COMPLETENESS_GENERAL_REVENUE_SUCCESS:
    case FETCH_COMPLETENESS_GENERAL_REVENUE_ERROR:
      return false
    default:
      return state
  }
}

const generalRevenue = (state = null, action) => {
  switch (action.type) {
    case FETCH_COMPLETENESS_GENERAL_REVENUE_SUCCESS:
      return action.data
    default:
      return state
  }
}

const isFetchingDelayedStores = (state = false, action) => {
  switch (action.type) {
    case FETCH_DELAYED_STORES:
      return true
    case FETCH_DELAYED_STORES_SUCCESS:
    case FETCH_DELAYED_STORES_ERROR:
      return false
    default:
      return state
  }
}

const delayedStores = (state = emptyArray, action) => {
  switch (action.type) {
    case FETCH_DELAYED_STORES_SUCCESS:
      return action.data
    default:
      return state
  }
}

export default combineReducers({
  isFetching,
  isFetchingClusters,
  list,
})

export const completeness = combineReducers({
  isFetchingCompletenessGeneralRevenue,
  isFetchingDelayedStores,
  generalRevenue,
  delayedStores,
})
